import { useQuery } from "react-query";
import GetSkusToNoteIdMap from "../services/getSkusToNoteIdMap";

function useGetSkusToNoteIdMap(token: string, orgRoleId: number | null) {
  return useQuery(
    ["get-skus-to-note-id-map", token, orgRoleId],
    () =>
      GetSkusToNoteIdMap({
        token,
        orgRoleId: orgRoleId!,
      }),
    {
      retry: false,
      enabled: !!token && !!orgRoleId,
    }
  );
}

export default useGetSkusToNoteIdMap;
